import { createAction } from '@reduxjs/toolkit'
import { type Notice } from './notices-types'

/* Action Creators */

// Regular-user-related actions //
export const FetchNoticesAction = createAction('notices/fetchAll/request')
export const FetchNoticesSuccessAction = createAction<Notice[]>('notices/fetchAll/success')
export const FetchNoticesFailureAction = createAction('notices/fetchAll/failure')

export const MarkNoticeAsReadAction = createAction<string>('notices/markAsRead/request')
export const MarkNoticeAsReadSuccessAction = createAction<Notice>('\'notices/markAsRead/success')

// Administrator-related actions //
export const CreateNewNoticeAction = createAction<string>('notices/create/request')
export const CreateNewNoticeSuccessAction = createAction<Notice>('notices/create/success')
export const CreateNewNoticeFailureAction = createAction('notices/create/failure')

export const DeleteNoticeAction = createAction<string>('notices/delete/request')
export const DeleteNoticeSuccessAction = createAction<string>('notices/delete/success')
export const DeleteNoticeFailureAction = createAction('notices/delete/failure')

export const ToggleCreateNoticeModalAction = createAction('notices/createModal/toggle')
